import { analytics } from './lib/services'

analytics()
